const formatCurrency = (amount) => {
    // TODO: Does this need to be localized?
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
  
    return formatter.format(amount);
  };
  
  export { formatCurrency };
  